import { devLogger } from "@/utils/dev-logger.util";
export const DropdownComponent = (element, props) => {
    const dropdownToggle = element.querySelector(".dropdown-toggle");
    const dropdownValue = element.querySelector(".dropdown-value");
    const dropdownMenu = element.querySelector(".dropdown-menu");
    const dropdownItems = element.querySelectorAll(".dropdown-menu li");
    if (!dropdownToggle || !dropdownValue || !dropdownMenu || dropdownItems.length === 0) {
        devLogger.warn("[DropdownComponent] Required elements not found");
        return;
    }
    const config = {
        onSelect: props?.onSelect || undefined,
    };
    // Detect which data attribute is used (category, articletype, or value)
    const getItemValue = (item) => {
        return item.dataset.category ?? item.dataset.articletype ?? item.dataset.value ?? "";
    };
    let isDropdownOpen = false;
    const setDropdownState = (open) => {
        isDropdownOpen = open;
        const state = open ? "open" : "closed";
        dropdownMenu.setAttribute("data-state", state);
        dropdownToggle.setAttribute("aria-expanded", open.toString());
    };
    const toggleDropdown = () => {
        setDropdownState(!isDropdownOpen);
    };
    const closeDropdown = () => {
        if (!isDropdownOpen)
            return;
        setDropdownState(false);
    };
    const updateDisplay = (value) => {
        if (value) {
            const selectedItem = Array.from(dropdownItems).find((item) => getItemValue(item) === value);
            dropdownValue.textContent = selectedItem?.textContent?.trim() || value;
        }
        dropdownItems.forEach((item) => {
            const itemValue = getItemValue(item);
            const isActive = itemValue === value;
            if (isActive) {
                item.classList.add("active");
            }
            else {
                item.classList.remove("active");
            }
        });
    };
    const handleItemClick = (item) => {
        const value = getItemValue(item);
        const text = item.textContent?.trim() || value;
        if (value === getCurrentValue()) {
            closeDropdown();
            return;
        }
        updateDisplay(value);
        closeDropdown();
        const selectEvent = new CustomEvent("dropdown:select", {
            detail: { value, text },
            bubbles: true,
            cancelable: true,
        });
        element.dispatchEvent(selectEvent);
        if (config.onSelect) {
            config.onSelect(value, text);
        }
    };
    const getCurrentValue = () => {
        const activeItem = Array.from(dropdownItems).find((item) => item.classList.contains("active"));
        return activeItem ? getItemValue(activeItem) : "";
    };
    const handleToggleClick = (e) => {
        e.stopPropagation();
        toggleDropdown();
    };
    dropdownToggle.addEventListener("click", handleToggleClick);
    const itemClickHandlers = new Map();
    dropdownItems.forEach((item) => {
        const handleClick = () => {
            handleItemClick(item);
        };
        itemClickHandlers.set(item, handleClick);
        item.addEventListener("click", handleClick);
    });
    const handleClickOutside = (e) => {
        if (!element.contains(e.target)) {
            closeDropdown();
        }
    };
    document.addEventListener("click", handleClickOutside);
    const handleUpdateEvent = (e) => {
        const customEvent = e;
        if (customEvent.detail?.value !== undefined) {
            updateDisplay(customEvent.detail.value);
        }
    };
    element.addEventListener("dropdown:update", handleUpdateEvent);
    const initialValue = getCurrentValue();
    if (initialValue !== undefined) {
        updateDisplay(initialValue);
    }
    return () => {
        dropdownToggle.removeEventListener("click", handleToggleClick);
        itemClickHandlers.forEach((handler, item) => {
            item.removeEventListener("click", handler);
        });
        document.removeEventListener("click", handleClickOutside);
        element.removeEventListener("dropdown:update", handleUpdateEvent);
    };
};
